export default __webpack_public_path__ + "static/phones-cropped-dbbdbccbfb44ee4cde19489c6a0da9ff.png";